import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import Style from "./OneProductDiscountContainer.module.scss";
import Select from "react-select";
import {
  AddDiscountAPI,
  getFoodCategoryApi,
  getSupermarketCategoryApi,
  getSupplierListApi,
  getSupplierProdctsAPI,
} from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";

const OneProductDiscountContainer = () => {
  const [searchAccardion, setSearchAccardion] = useState(false);
  const [, setisDisableCategory] = useState(true);
  const [suppliersState, setSuppliersState] = useState(null);
  const [supplierSelectState, setSupplierSelect] = useState(null);
  const [, setResturanCategoryState] = useState(null);
  const [, setSupperMarketCategoryState] = useState(null);
  const [DiscountType, setDiscountType] = useState(null);
  const [productsState, setProductState] = useState(null);
  const [productSelect, setProductSelect] = useState(null);
  const [disable, setDisable] = useState(false);
  const [productNameSearch, setProductNameSearch] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onsubmit = (data) => {
    setDisable(true);
    let info = {
      id: 0,
      product_id: productSelect.id,
      supplier_id: supplierSelectState.value,
      const: data.CountDiscount === undefined ? 0 : data.CountDiscount,
      precentage: data.PrecentDiscount === undefined ? 0 : data.PrecentDiscount,
    };
    AddDiscountAPI(info, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        setDisable(false);
      } else {
        errorToast(succ.message);
        setDisable(false);
      }
    });
  };
  useEffect(() => {
    getAllSupplierData();
  }, []);
  const getAllSupplierData = async () => {
    getSupplierListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setSuppliersState(res.suppliers)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  const SupplierChangeHandler = async (value) => {
    setisDisableCategory(false);
    setSupplierSelect(value);
    if (value.label.split(" ").at(-1) === "(رستوران)") {
      getFoodCategoryApi(value.value, (succ, res) => {
        if (succ) {
          if (res.status === 0) {
            errorToast("مشکلی پیش آمده است");
          } else {
            setResturanCategoryState(res.category);
            setSupperMarketCategoryState(null);
          }
        } else {
          errorToast("خطایی در سرور رخ داده است");
        }
      });
    } else {
      getSupermarketCategoryApi((succ, res) => {
        if (succ) {
          if (res.status === 0) {
            errorToast("مشکلی پیش آمده است");
          } else {
            setSupperMarketCategoryState(res.category);
            setResturanCategoryState(null);
          }
        } else {
          errorToast("خطایی در سرور رخ داده است");
        }
      });
    }
    const supplierProductData = await getSupplierProdctsAPI(value.value);
    setProductState(supplierProductData.products);
  };

  const DiscountTypeChangeHandler = (e) => {
    setDiscountType(e.target.value);
  };
  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const getProductSelectDetail = (value) => {
    setProductSelect(value);
    setProductNameSearch(value.name);
    setSearchAccardion(false);
  };

  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"ایجاد تخفیف روی یک کالا"} />
      <div className={Style.imgHolder}>
        <img src="/Assets/Images/assignProduct/restaurant.svg" alt="" />
      </div>
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <div className={Style.inputHolder}>
          <Select
            options={
              suppliersState &&
              suppliersState.map((item) => {
                return {
                  value: item.id,
                  label: `${item.name} ${
                    item.type === "supermarket" ? "(سوپرمارکت)" : "(رستوران)"
                  }`,
                };
              })
            }
            className={Style.selectOptionsearch}
            placeholder={"تامین کننده"}
            onChange={SupplierChangeHandler}
          />
          {/* <Select
            options={
              ResturanCategoryState !== null
                ? ResturanCategoryState.map((item) => {
                    return {
                      value: item.id,
                      label: item.category,
                    };
                  })
                : SupperMarketCategoryState &&
                  SupperMarketCategoryState.map((item) => {
                    return {
                      value: item.id,
                      label: item.category,
                    };
                  })
            }
            className={Style.selectOptionsearch}
            placeholder={"دسته بندی"}
            onChange={CategoryChangeHandler}
            isDisabled={isDisableCategory}
          /> */}
          <div className={Style.SearchProductDivison}>
            <input
              className={errors.count ? Style.errorInput : Style.inputSearch}
              placeholder={"انتخاب محصول"}
              onChange={(e) => {
                setProductNameSearch(e.target.value);
                setSearchAccardion(true);
              }}
              value={productNameSearch}
            />
            <ul
              style={{
                display:
                  !searchAccardion || productNameSearch.length === 0
                    ? "none"
                    : "flex",
              }}
              className={Style.ProductListHolder}
            >
              {productsState &&
                productsState
                  .filter((value) => {
                    if (value.name === null) {
                      return null;
                    } else if (value.name.includes(productNameSearch)) {
                      return value;
                    } else if (productNameSearch === "") {
                      return value;
                    }
                  })
                  .map((item) => {
                    return (
                      <li
                        key={item.id}
                        className={Style.EachProduct}
                        onClick={() => getProductSelectDetail(item)}
                      >
                        <div className={Style.ImageHolder}>
                          <img
                            src={`https://cdn.barest.ir/product/m/${
                              item.id
                            }.jpg?${randomNumberInRange(1, 1000000000000)}`}
                            alt=""
                          />
                        </div>
                        <div className={Style.ProductInfo}>
                          <h4>{item.name}</h4>
                          <p>
                            {separate(
                              item.off_price === "0"
                                ? item.price
                                : item.off_price
                            )}
                          </p>
                        </div>
                      </li>
                    );
                  })}
            </ul>
          </div>

          <select
            name=""
            id=""
            className={errors.maxCount ? Style.errorInput : Style.inputPart}
            onChange={DiscountTypeChangeHandler}
          >
            <option value="0">نوع تخفیف انتخاب کنید</option>
            <option value="2">درصد</option>
            <option value="1">مقدار</option>
          </select>
          {DiscountType === "1" ? (
            <input
              className={errors.maxCount ? Style.errorInput : Style.inputPart}
              placeholder={"مقدار تخفیف"}
              {...register("CountDiscount", { required: true })}
            />
          ) : DiscountType === "2" ? (
            <input
              className={errors.price ? Style.errorInput : Style.inputPart}
              placeholder={"درصد تخفیف"}
              {...register("PrecentDiscount", { required: true })}
            />
          ) : null}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default OneProductDiscountContainer;
